import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import classNames from "classnames"

import { InputCell } from "app/static/frontend/sheets/components/cells/MantineCells/InputCell"
import { ErrorCell } from "app/static/frontend/sheets/components/cells/MantineCells/ErrorCell"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

import { statCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"
import { formatNumber } from "app/static/frontend/sheets/helper-functions"
import { formatNumberWithCurrencyPrecision, formatPercentageForDisplay } from "shared/imports/sharedHelperFunctions"
import { statCellError } from "app/static/frontend/sheets/components/helpTexts"
import { checkHasPermission } from "shared/imports/permissionFunctions"

const StatCellComponent = ({
    barWidth,
    children,
    columnId,
    columnIndex,
    cellIsEditable,
    derived,
    editing,
    isEditable,
    row,
    rowId,
    sheetId,
    shouldDisplayAsCurrency,
    shouldRoundCellValue,
    isRenderingPercent,
    columnDataType,
    ...props
}) => {
    if (editing && isEditable && cellIsEditable) {
        return (
            <InputCell
                type="number"
                columnId={columnId}
                isResourceTable={props.isResourceTable}
                rowId={rowId}
                sheetId={sheetId}
                width={props.width}
                field={props.field}
                row={row}
            >
                {children}
            </InputCell>
        )
    }
    if (children === null || children === undefined || children === "") {
        return <CellWrapper {...props}>{children}</CellWrapper>
    }

    // if there were errors computing the cell value, display to user reason
    if (Number.isNaN(children) || children === Infinity) {
        return (
            <CellWrapper {...props} style={statCellError.dividyByZero.cellStyles}>
                <ErrorCell tooltipLabel={statCellError.dividyByZero.tooltipText} iconClassName="cell-error-centered" />
            </CellWrapper>
        )
    }

    const isForcedCurrency = checkHasPermission([DjangIO.app.models.PermissionType.qpac_v1]) && shouldDisplayAsCurrency
    const isPercentColumnDataType =
        columnDataType === DjangIO.app.userdata.spreadsheet.data_types.ColumnDataType.percent.value

    const formattingFn = (value) =>
        isForcedCurrency
            ? formatNumberWithCurrencyPrecision(Number(value))
            : isRenderingPercent || isPercentColumnDataType
              ? formatPercentageForDisplay(Number(value), shouldRoundCellValue)
              : formatNumber(Number(value), shouldRoundCellValue)

    return (
        <CellWrapper {...props} isNumeric>
            {formattingFn(children)}
        </CellWrapper>
    )
}

export const StatCell = connect(statCellConnection, {})(StatCellComponent)

StatCellComponent.propTypes = {
    editing: PropTypes.bool,
    isEditable: PropTypes.bool,
    shouldRoundCellValue: PropTypes.bool.isRequired,
    isRenderingPercent: PropTypes.bool,
    cellIsEditable: PropTypes.bool,
}

StatCellComponent.defaultProps = {
    // keep for backwards compatibility. Eventually should be switched
    // when redoing Sheet.jsx and columnIsEditable
    isEditable: true,
    editing: false,
    isRenderingPercent: false,
    cellIsEditable: true,
}
